import * as React from "react";
import { GlobalHead } from "@base/GlobalHead";
import { LocationProvider } from "@gatsbyjs/reach-router";
import { RootStore } from "@base/RootStore";
import { DevToolbar } from "@base/lib/dev-toolbar/DevToolbar";

/** Wraps every page but is not re-mounted when chaning pages */
export function RootWrapper(props: React.PropsWithChildren) {
  return (
    <LocationProvider>
      <RootStore>
        <GlobalHead />
        {props.children}
        <DevToolbar />
      </RootStore>
    </LocationProvider>
  );
}
